<script>
export default {
  name: "ObjectNameComponent",
  props: {
    index: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div class="name">
    <span>{{ index }}. {{ name }}</span>
  </div>
</template>

<style scoped>

.name {
  text-align: left;
  margin-bottom: 5px;
}

@media (max-width: 768px) {

  .name {
    margin-bottom: 10px;
    font-size: 17px;
  }

}

</style>
